// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sen-styles-wrapper-jitJ2JSK{padding:16px}`, "",{"version":3,"sources":["webpack://./src/components/LoginAuth0/styles.scss"],"names":[],"mappings":"AAAA,6BACI,YAAA","sourcesContent":[".wrapper {\n    padding: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `sen-styles-wrapper-jitJ2JSK`
};
export default ___CSS_LOADER_EXPORT___;
